<div class="container-tab-lists new-table-style" id="niops">

  <div class="inner-tcontainer-tab">

    <h2>{{title}}</h2>
    <div style="display:flow-root">
      <div style="text-align:right; float:right">
        @if (!isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Excel" (click)="onClickExcelButton()">
            Excel
          </a>
        }
        @if (isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Download" (click)="downloadExcelInformation()">
            <span class='glyphicon glyphicon-download'></span> Download
          </a>
        }

        @if (isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Upload" (click)="goUploadFileView()">
            <span class='glyphicon glyphicon-upload'></span> Upload
          </a>
        }

        @if (isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Cancel" (click)="onClickCancelButton()">
            {{'Exit Excel mode'}}
          </a>
        }
        <a class="kpi-button-menu" title="UploadUserHistory" (click)="onClickUploadUserHistory()">
          Upload User History
        </a>
        <a class="kpi-button-menu" title="Delete" (click)="onClickDelete()">
          Delete
        </a>
      </div>
    </div>
  </div>
</div>